import { Base } from '@app/shared/models/base.model'
import { User } from '@app/modules/user/user.model'
import { Person } from '@app/modules/person/person.model'
import { DeleteId } from '@app/modules/delete-id/delete-id.model'

export class ContactGroup extends Base {
  uuid: string = null
  name: string = null
  description: string = null
  customQuery: string = null
  savedQueryUuid: string = null
  contacts: Array<Person> = []
  userToContactGroup: any
  // ---------------------------------------------------------------------------
  createdAt: Date = null
  updatedAt: Date = null
  deletedAt: Date = null
  createdByUuid: string = null
  createdByUser: User = null
  updatedByUuid: string = null
  updatedByUser: User = null
  // ---------------------------------------------------------------------------
  // Keep track of pivot items we want to delete when they are removed
  // from the form.
  contactsDeleted: Array<DeleteId> = []

  /**
   * Properties with type Date
   *
   * @type {Array<string>}
   */
  protected _dates: Array<string> = [
    'createdAt',
    'updatedAt',
    'deletedAt'
  ]

  /**
   * Constructor
   *
   * @param {Partial<ContactGroup>} data Initial values
   */
  public constructor (data?: Partial<ContactGroup>) {
    super(data)
    this.init(data)
  }
}
